'use client'

import { ApplicationContextProvider } from "@directv-digital/dds.server.application-context";

export function ApplicationContext({ children, value }: { children: React.ReactNode, value: any }) {
  return (
    <ApplicationContextProvider value={value}>
      {children}
    </ApplicationContextProvider>
  );
}
